document.addEventListener('DOMContentLoaded', () => {
  const productHandle = document
    .querySelector('.js-product')
    ?.getAttribute('data-product');

  // Trigger Facebook Pixel tracking for the product page
  if (window.fbq) {
    window.fbq('trackCustom', 'ViewItem', { product: productHandle });
  }
});
